import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import videojs from 'video.js';
import {
  setCurrentTime,
  setTimeForVideoToPlay,
  videoEnded,
} from '@/actions/helperAction';
import { minutesToSecond, secondsToHms } from '@/helpers/timeHelper';
require('videojs-seek-buttons');
require('videojs-contrib-quality-levels');
require('videojs-hls-quality-selector');
// require('@silvermine/videojs-quality-selector')(videojs);
// require('@silvermine/videojs-quality-selector/dist/css/quality-selector.css')

export const VideoPlayer = (props) => {
  const dispatch = useDispatch();

  // const videoRef = React.useRef(null);
  const {
    options,
    timeoutAction = true,
    videoEnd,
    prevVideo = null,
    videoHeading = null,
    watermark,
    videoRef = React.useRef(null),
    onMouseEnter = null,
    onMouseLeave = null,
    customID = "",
    seekButtons = true
  } = props;
  let player;

  const videoTime = useSelector((state: any) => state?.helperReducer?.videoTime);
  const videoPause = useSelector((state: any) => state?.helperReducer?.videoPause);
  const [currentVideoTime, setCurrentVideoTime] = React.useState(null);

  useEffect(() => {
    // dispatch(toggleVideoPause());
    dispatch(setTimeForVideoToPlay(null));
  }, []);

  useEffect(() => {
    const videoElement = videoRef?.current;
    if (videoElement) {
      player = videojs(videoElement, options, () => {
        var bigbtn: HTMLElement = document.querySelector('.vjs-big-play-button');
        var vJsGradientBottom = document.createElement("div");
        var vjsControlBar = document.querySelector(".vjs-control-bar");
        vJsGradientBottom.classList.add("vjs-gradient-bottom");
        vjsControlBar.parentNode.insertBefore(vJsGradientBottom, vjsControlBar);
        if (videoHeading) {
          var videoHeader: HTMLElement = document.createElement('div');
          videoHeader.classList.add('header-text-videojs');
          var headingTextNode = document.createTextNode(videoHeading);
          videoHeader.appendChild(headingTextNode);
          bigbtn.parentNode.insertBefore(videoHeader, bigbtn);
        }
        var videoWaterMark: HTMLImageElement = document.createElement('img');
        videoWaterMark.classList.add('videowatermark');
        videoWaterMark.src = '/../../logo.svg';
        watermark ? bigbtn.parentNode.insertBefore(videoWaterMark, bigbtn) : '';

        // Play video at current time when clicked on certain saved note
        if (videoTime !== null) {
          player.currentTime(minutesToSecond(videoTime));
          player.pause();
        }
        if (seekButtons) {
          player.seekButtons({
            forward: 5,
            back: 5,
          });
        }
        player.on('pause', function () {
          player.bigPlayButton.show();
          player.one('play', function () {
            player.bigPlayButton.hide();
          });
        });
        player.hlsQualitySelector({
          displayCurrentQuality: true,
        });
        try {
          player.on('ended', function () {
            dispatch(videoEnded('success'));
          });
        } catch (err) {
          console.log('Error', err);
        }

        // Only for video time taking process
        if (timeoutAction) {
          player.on('timeupdate', function () {
            dispatch(setCurrentTime(secondsToHms(player.currentTime().toString())));
          });
        }
      });
    }

    return () => {
      if (player) {
        player.dispose();
      }
    };
  }, [options, videoTime, currentVideoTime]);
  const VideoHtml = (props) => (
    <div>
      <video
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        id={`learnsic-player`}
        ref={videoRef}
        className={`video-js vjs-theme-forest vjs-big-play-centered
         ${videoEnd ? 'videoLoading' : ''
          }
        `}
        style={{ paddingTop: '56.25%' }}
        controlsList="nodownload"
      />
    </div>
  );

  return <VideoHtml />;
};;
export default VideoPlayer;
